import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  select: {
    maxWidth: 190,
    fontSize: 14,
  }
});

export default useStyles;
